// Section 17: the four ration policies.
import type { Config } from '../../config';
import { checkRegistryKeys, type RationPolicyDef } from '../../core/registry';
import type { RationPolicyId } from '../../core/types';
import { equal } from './equal';
import { floorPriority } from './floor-priority';
import { manual } from './manual';
import { priority } from './priority';

/** Build the rationPolicies registry for a config (content numbers come from the config, ADR-0008). */
export function buildRationPolicies(config: Config) {
  const rationPolicies = Object.freeze({
    equal: equal(config),
    'floor-priority': floorPriority(config),
    priority: priority(config),
    manual: manual(config),
  } satisfies Record<RationPolicyId, RationPolicyDef>);
  checkRegistryKeys('rationPolicies', rationPolicies);
  return rationPolicies;
}
